import { render } from "./MainAccess.vue?vue&type=template&id=32f4b1be&scoped=true"
import script from "./MainAccess.vue?vue&type=script&lang=js"
export * from "./MainAccess.vue?vue&type=script&lang=js"

import "./MainAccess.vue?vue&type=style&index=0&id=32f4b1be&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f4b1be"]])

export default __exports__